<script setup>
import { useProductsStore } from '@/stores/products.store';
import { categoryCoverSrc } from '@/helpers/imageUrls.js';
import { categoryPagePath } from '@/helpers/seo.js';

const props = defineProps({
    categoryData: Object,
    selectedCategory: Number,
    isFastDelivery: {
        type: Boolean,
        default: false
    },
});

const emit = defineEmits(['select']);

function onActivate(event) {
    event.preventDefault();
    useProductsStore().emptySearch();
    emit('select', props.categoryData);
}

</script>
<template>
    <a
        v-if="isFastDelivery ? isFastDelivery && categoryData.is_fastdelivery : categoryData.is_fastdelivery === false"
        :href="categoryPagePath(categoryData.id)"
        class="inline-block shrink-0 px-0.5 sm:px-1"
        @click="onActivate">
        <div
            class="p-2 select-none cursor-pointer rounded-2xl min-w-40 max-w-40 min-h-20 bg-cover bg-center"
            :class="{
                'border border-tazej-gold-primary shadow-master ': (categoryData.id == selectedCategory)
            }"
            :style="{
                backgroundImage: categoryData.cover_image
                    ? `linear-gradient(to bottom, #0000 20%, #408E58 100%), url('${categoryCoverSrc(categoryData)}')`
                    : `linear-gradient(to bottom, #0000 20%, #408E58 100%) ,url('/public/img/categoryImage.png')`
            }">
            <div class="rounded-md p-2 w-full h-full min-h-[4.5rem] flex items-end justify-center">
                <h3 class="w-full text-center text-sm text-white font-bold leading-snug line-clamp-2">{{ categoryData.name }}</h3>
            </div>
        </div>
    </a>
</template>
